import { computeStatics, BLOCK_KG } from "./statics";

import { tr } from "@/lib/i18n";
const HOOKS = {
  tegole: ["SR-HK-TG", "Gancio regolabile per tegole/coppi"],
  lamiera: ["SR-HK-LM", "Staffa per lamiera grecata"],
  ardesia: ["SR-HK-AR", "Gancio per ardesia/scandole"],
  altro: ["SR-HK-VP", "Vite prigioniera M10 x 200 mm"],
};

function segments(active) {
  const rows = {};
  active.forEach((c) => (rows[c.r] = rows[c.r] || []).push(c));
  const segs = [];
  Object.values(rows).forEach((cells) => {
    cells.sort((a, b) => a.c - b.c);
    let cur = [cells[0]];
    for (let i = 1; i <= cells.length; i++) {
      if (i < cells.length && cells[i].c === cells[i - 1].c + 1) cur.push(cells[i]);
      else { segs.push(cur); cur = [cells[i]]; }
    }
  });
  return segs;
}

export function computeBOM(project, layout) {
  const statics = computeStatics(project, layout);
  const m = layout.module;
  const n = layout.active.length;
  const items = [];
  const add = (code, desc, qty, weight) => qty > 0 && items.push({ code, desc, unit: tr("pz"), qty, weight });
  let extra = {};
  const allSegs = layout.fields.map((f) => ({ f, st: statics.fields.find((s) => s.fid === f.roof.id), segs: segments(f.active) }));
  if (!layout.flat) {
    let rails = 0, conn = 0, hooks = 0, ec = 0, mc = 0, railLen = 0;
    allSegs.forEach(({ st, segs }) => segs.forEach((seg) => {
      const k = seg.length;
      const len = k * layout.du + (k - 1) * layout.gu + 0.1;
      const sec = Math.ceil(len / 3.6);
      const bays = seg.reduce((s, c) => s + (layout.du + layout.gu) / st.zones[c.zone].span, 0);
      rails += 2 * sec; conn += 2 * (sec - 1);
      hooks += 2 * (Math.ceil(bays) + 1);
      ec += 4; mc += 2 * (k - 1); railLen += 2 * len;
    }));
    const [hc, hdRaw] = HOOKS[project.covering] || HOOKS.altro;
    const hd = tr(hdRaw);
    add("SR-RL-360", tr("Binario in alluminio 3,60 m"), rails, 4.0);
    add("SR-RC-01", tr("Giunto per binario"), conn, 0.3);
    add(hc, hd, hooks, 1.1);
    add("SR-TB-M8", tr("Vite a testa martello M8 + dado flangiato"), hooks, 0.05);
    add("SR-SC-8100", tr("Vite per legno 8 x 100 mm"), hooks * 2, 0.04);
    add("SR-EC-35", tr("Morsetto terminale 30-40 mm"), ec, 0.1);
    add("SR-MC-35", tr("Morsetto centrale 30-40 mm"), mc, 0.1);
    add("SR-CAP", tr("Tappo terminale binario"), ec, 0.01);
    const spans = statics.fields.flatMap((f) => Object.values(f.zones).map((z) => z.span));
    extra = { hooks, railLen, hookSpacing: spans.length ? Math.min(...spans) : 0 };
  } else {
    const t = Number(project.modules.tilt) || 10;
    let sup = 0, ec = 0, mc = 0, blocks = 0;
    allSegs.forEach(({ st, segs }) => segs.forEach((seg) => {
      const k = seg.length;
      sup += k + 1; ec += 4; mc += 2 * (k - 1);
      blocks += seg.reduce((s, c) => s + st.zones[c.zone].blocks, 0);
    }));
    add(`SR-FB-${t}F`, tr("Supporto anteriore zavorrato {0}°", [t]), sup, 1.2);
    add(`SR-FB-${t}R`, tr("Supporto posteriore zavorrato {0}°", [t]), sup, 1.6);
    add("SR-WD", tr("Deflettore vento posteriore"), n, 2.2);
    add("SR-EC-35", tr("Morsetto terminale 30-40 mm"), ec, 0.1);
    add("SR-MC-35", tr("Morsetto centrale 30-40 mm"), mc, 0.1);
    add("SR-MAT", tr("Tappetino protettivo antiscivolo"), sup * 2, 0.2);
    add("SR-BL-125", tr("Blocco zavorra in cls 12,5 kg"), blocks, BLOCK_KG);
    extra = { ballastKg: blocks * BLOCK_KG, ballastPerModule: n ? blocks / n : 0 };
  }
  const ov = project.bom_overrides || {};
  const all = [
    ...items.map((i) => ({ ...i, calc: i.qty, qty: ov[i.code] ?? i.qty })),
    ...(project.bom_extra || []).map((e, idx) => ({ ...e, idx, custom: true, unit: e.unit || tr("pz"), weight: Number(e.weight) || 0 })),
  ];
  const moduleArea = (n * m.length * m.width) / 1e6;
  const structKg = all.reduce((s, i) => s + (Number(i.qty) || 0) * (i.weight || 0), 0);
  const totalKg = structKg + n * m.weight;
  return {
    items: all,
    statics,
    stats: {
      modules: n, kwp: (n * m.power) / 1000, moduleArea, structKg, totalKg,
      perM2: moduleArea ? totalKg / moduleArea : 0, roofArea: layout.roofArea || 0,
      hooksPerM2: extra.hooks && moduleArea ? extra.hooks / moduleArea : 0,
      ballastPerM2: extra.ballastKg && moduleArea ? extra.ballastKg / moduleArea : 0,
      ...extra,
    },
  };
}
